// 播放器状态
export enum PlayerState {
  Stopped = 1,
  Playing,
  Paused,
  Resume,
  Downloading,
  Uploading,
  Failed,
}

// 播放器动作
export enum PlayerAction {
  Stop = 1,
  Play,
  Pause,
  Resume,
  Download,
  Upload,
}
